const JPN = {
  yen: '円',
  error: {
    server_error: 'サーバーでエラーが発生しました。',
    invalid_password: 'ログインに失敗しました。',
    toke_expired_or_not_valid_now: '有効期間外です。',
    temppermission_time_conflict:
      'この時間帯は予約済みです。有効期間を変更してください。',
    time_conflict: 'この時間帯は予約済みです。期間を変更してください。',
    invalid_patient_email: '有効なアカウントを入力してください。',
    admin_no_already_exists: 'すでに同じ管理番号があります',
    email_already_exists: 'アカウントが既に存在します。',
    invalid_verification_code: '認証コードが無効です。',
    verification_code_expired: '認証コードが無効になりました。',
    duplicate_email:
      'このアカウントは既に登録されています。別のメールアドレスをご利用ください。',
    jemaError:
      '改善されない場合は、本体のSTATUSランプをご確認ください。\n・緑色で点灯している場合は、通信が正常でサポートにお問い合わせください。\n・点灯していない場合は、通信環境を確認し、本体の電源やWi-Fiルーターの電源を再起動してみてください。',
    please_accept_terms: '利用規約に同意してください。',
    cannot_delete_patient_info_with_unpaid_appointments:
      '支払待ちの予約があります。お支払い後に削除してください',
    cannot_delete_only_default_patient_info: '使用中の利用者は削除できません。',
    duplicate_patient_name: '利用者が既に存在します。',
  },
  notification: {
    answered: 'コール対応済み',
    not_answered: 'コール未対応',
  },
  lockOpen: {
    enterPassword: 'パスワードを入力',
    invalidTeservationPeriod: '有効期間外です。',
  },
  reservation: {
    noDevice: '対象機器がありません',
    reservation: '内覧予約',
    reservationList: '予約一覧',
    clientName: 'お客様情報',
    clientNamePlaceHolder: 'お客様の情報を入力してください',
    url: 'URL',
    urlPlaceHolder: '保存ボタンが押されると自動表示します',
    effectiveTime: '有効期間',
    reservationPassword: 'ログインパスワード',
    reservationPasswordPlaceHolder: '右側の更新ボタンを押してください',
    warning:
      '※保存してから、送信ボタンを押すとメールアドレス入力画面へ遷移します。',
    startDate: '開始日',
    endDate: '終了日',
    dateError: '開始日と終了日を空にすることはできません',
    urlDialogTitle: 'URLと有効期間を送信します。',
    passwordDialogTitle: 'ログインパスワードを送信します。',
    dialogSubtitle: 'メールアドレスを入力してください。',
    emailError: '無効なメールアドレス',
    tempPermissionList: '予約一覧',
    emailSentSuccess: 'success to send email',
    tempPermissionUpdated: '予約変更',
    tempPermissionCreated: '予約保存',
    tempPermissionDeleted: '予約削除',
    noActionAvailable: 'No action available',
    confirmDeleteTempPermission: 'この予約を取り消しますか？',
    detailSetting: '詳細設定',
    detailSettingPlaveHolder:
      'エアコン、ロックなどを設定する場合、右側のボタンを押してください',
    detailSettingDialogSubtitle: '設定内容を選択してください。',
    detailSettingDialog: {
      autoAC: {
        title: 'エアコン 自動 ON / OFF',
        subtitle: '※内覧開始30分前に ON、内覧終了時に OFF。',
      },
      autoLock: {
        title: 'ロック自動施錠',
        subtitle: '※内覧終了時に自動施錠。',
      },
      akuvoxPin: {
        title: ' Akuvox(R29C) パスワード設定',
        subtitle: '※設定したパスワードでスマートインターホンを解錠。',
      },
    },
  },
  tempPermissionList: {
    table: {
      edit: '編集',
      name: 'お客様',
      timeRange: '有効期間',
      status: '状態',
      note: 'メモ',
      statusUpcoming: '予約中',
      statusPast: '内覧終了',
      statusActive: '内覧中',
      statusDisabled: 'キャンセル',
    },
  },
  action: {
    ok: 'OK',
    cancel: 'キャンセル',
    close: '閉じる',
    save: '保存',
    editAndSave: '編集を保存',
    cancelPermission: '予約の取消',
    set: '設定',
    to_setting: '設定へ',
    refresh: '更新',
    edit: '編集',
    change: '変更',
    delete: '削除',
    new: '+',
    next: '次へ',
    more_detail: '詳細',
    device_reset: 'デバイスをリセットしました',
    retry: 'リトライ',
    return: '戻る',
    contact_support: 'サポートへ連絡',
    add_appliances: '家電の追加',
    relearn: '再学習する',
    rename_button: 'ボタンの名称の変更',
    yes: 'はい',
    no: 'いいえ',
    start: 'スタート',
    mute_nexttime: '次回から非表示',
    confirmDelete: 'を削除しますか？',
    send: '送信',
    cancelTempPermission: '編集をキャンセル',
  },
  user: {
    title: 'アカウント',
  },
  manageFamily: {
    title: 'グループ管理',
    building: 'グループ',
    unassign: '未設定',
    deleteFamily: 'ホーム編集',
    editBuilding: 'グループ名称変更',
    deleteBuilding: 'グループ削除',
    searchFamilyPlaceholder: 'ホーム名称を入力してください',
    createBuildingDialog: {
      title: '名称を入力してください',
      inputName: '名称',
      inputNameError: 'Building name can not be empty',
    },
    editBuildingDialog: {
      title: '名称を入力してください',
      inputName: '名称',
      inputNameError: 'Building name can not be empty',
    },
    editCurrentGroupDialog: {
      title: '棟',
      editName: '名称変更',
      editGroup: '所属変更',
    },
    editGroupDialog: {
      title: 'グループ',
      editName: '名称変更',
    },
    assignFamilyDialog: {
      title: '所属を選択してください',
      selectGroup: 'グループ',
      selectGroupError: 'Please select a group',
      selectBuilding: '棟',
      selectBuildingError: 'Please select a building',
      current: '(現在所属)',
    },
    assignBuildingDialog: {
      title: '所属を選択してください',
      selectGroup: 'グループ',
      selectGroupError: 'Please select a group',
      selectBuilding: '棟',
      selectBuildingError: 'Please select a building',
      current: '(現在所属)',
    },
    batchDeleteFamilyDialog: {
      title: 'batch delete',
      subtitle: '确认删除选中的{{itemCount}}项family',
    },
    editFamilyDialog: {
      title: 'のQRコード',
      inputName: '名称',
      inputNameError: 'Building name can not be empty',
      managePermissions: '権限管理',
      permissionText:
        '初期化:初期化後、今までの利用者がご利用できなくなります。',
      permissionReset: '初期化します',
      permissionReseted: '初期化完了',
      name: '名称',
      belongTo: '所属',
      managementNumber: '管理番号',
      enterIfNeeded: '必要な場合に入力',
      detailSettingsExplain:
        '入居状況またはオートロックなどを設定する場合、右側のボタンを押してください ',
      detailSettings: '詳細設定',
      confirmReset: '初期化しますか?',
      resetWarning1: '初期化後、',
      resetWarning2: '今までの利用者がご利用できなくなります',
      editNameTitle: '名称を入力してください',
      editNameError: 'Family name can not be empty',
    },
    editManagementNumberDialog: {
      title: '管理番号を入力してください',
      inputName: '管理番号',
      inputNameError: '入力を空にすることはできません',
    },
    editDetailSettingsDialog: {
      title: '詳細設定',
      subtitle: '設定内容を選択してください',
      chooseOnlyOne: '（同時選択不可）',
      occupied: '入居',
      occupiedDetail:
        '※チェックを入れると内覧機能がOFFに、既存予約は無効になります',
      autoLock: 'オートロック',
      autoLockDetail: '※解錠後、５分後自動で施錠する機能',
    },
    successMessage: {
      family_create_success: 'success to create family',
      family_update_success: 'success to update family',
      family_delete_success: 'success to delete family',
      building_create_success: 'success to create building',
      building_update_success: 'success to update building',
      building_delete_success: 'success to delete building',
    },
    errorMessage: {
      family_create_error: 'failed to create family',
      family_update_error: 'failed to update family',
      family_delete_error: 'failed to delete family',
      building_create_error: 'failed to create building',
      building_update_error: 'failed to update building',
      building_delete_error: 'failed to delete building',
      qrCode_load_error: 'failed to load QR code',
      qrCode_refresh_error: 'failed to refresh QR code',
    },
  },
  messageFamily: {
    title: 'メッセージ送信',
    messager: '管理者',
    subtitle: '連絡先',
    messageAll: '全ホームへ送信',
    sendMessage: '送信',
    loadingMoreMessage: 'Loading more messages',
    endOfMessages: 'これ以上はありません',
    noMessages: '履歴はありません',
    noChannels: '連絡先はありません',
  },
  manageAccount: {
    title: 'アカウント管理',
    subAccount: 'サブアカウント',
    createNewAccount: 'サブアカウント 新規作成',
    permission: '権限',
    managePermissions: '権限管理',
    inputName: '表示名入力',
    inputNamePlaceHolder: '表示名',
    inputEmail: 'メールアドレス入力',
    inputEmailPlaceHolder: 'メールアドレス',
    inputPassword: 'パスワード入力',
    inputPasswordPlaceHolder: 'パスワードを８桁以上で入力してください',
    permissions: {
      homeQR: {
        title: 'ホーム QR コード確認 & 保存',
        subtitle: '',
      },
      homeInit: {
        title: 'ホーム 初期化',
        subtitle: '※初期化後、今までの利用者がご利用できなくなります。',
      },
      homeEdit: {
        title: 'ホーム 名称変更',
        subtitle: '',
      },
      homeMove: {
        title: 'ホーム 所属グループ移動',
        subtitle: '',
      },
      homeDelete: {
        title: 'ホーム 削除',
        subtitle: '',
      },
      groupEdit: {
        title: 'グループ 名称変更',
        subtitle: '',
      },
      groupDelete: {
        title: 'グループ 削除',
        subtitle: '',
      },
      deviceDisplay: {
        title: 'デバイス表示 & 家電表示',
        subtitle: '',
      },
      deviceControl: {
        title: '家電操作',
        subtitle: '',
      },
      notificationAll: {
        title: 'メッセージ送信',
        subtitle: '',
      },
      // "notificationEach": {
      //   "title": '各ホームへ送信',
      //   "subtitle": '',
      // },
    },
    successMessage: {
      subAccount_create_success: 'success to create sub account',
      subAccount_update_success: 'success to update sub account',
      subAccount_delete_success: 'success to delete sub account',
    },
    errorMessage: {
      subAccount_create_error: 'failed to create sub account',
      subAccount_update_error: 'failed to update sub account',
      subAccount_delete_error: 'failed to delete sub account',
    },
  },
  miwaLock: {
    openActionSuccess: 'Opened',
    lockActionSuccess: 'Locked',
  },
  tv_panel: {
    actionSuccess: 'SUCCESS',
    button_power: '電源',
    button_volume_up: '音量+',
    button_volume_down: '音量-',
    button_channel_up: 'チャンネル＋',
    button_channel_down: 'チャンネル-',
    button_up: '上',
    button_down: '下',
    button_left: '左',
    button_right: '右',
    button_input_switch: '入力切替',
    button_guide: '番組表',
    button_ground: '地上',
    button_bs: 'BS',
    button_cs: 'CS',
    button_vol: 'vol',
    button_channel: 'ch',
    button_sound_switch: '音声切替',
    button_subtitle: '字幕',
    button_mute: '消音',
    button_home: 'ホーム',
    button_sub_menu: 'メニュー',
    button_return: '戻る',
    button_end: 'サブメニュー',
    button_ok: 'OK',
    button_1: '1',
    button_2: '2',
    button_3: '3',
    button_4: '4',
    button_5: '5',
    button_6: '6',
    button_7: '7',
    button_8: '8',
    button_9: '9',
    button_10: '10',
    button_11: '11',
    button_12: '12',
    button_0: '/0',
    button_record_list: '録画リスト',
    button_record: '録画',
    button_display: '画面表示',
    button_data: 'Dデータ',
    button_blue: '青',
    button_red: '赤',
    button_green: '緑',
    button_yellow: '黄',
  },
  ac_panel: {
    actionSuccess: 'SUCCESS',
    match_title: '自動マッチング',
    match_brand: '［  メーカー：{{name}}  ］',
    match_tips:
      'プリセット対応のエアコンか自動確認します。リモコンを{{name}}に向けて、電源／冷暖房のいずれかのボタンを押してください。',
    match_go_to_manual_learning: '別の方法（手動）マッチングを試す',
    select_tips: '右上の「保存」をタッチすると表示内容を設定します。',
    status_off: 'OFF',
    wind_speed_auto: 'AUTO',
    button_on: 'ON',
    button_off: 'OFF',
    button_temperature: '温度',
    button_wind_speed: '風量',
    wind_speed_text_low: '弱風量',
    wind_speed_text_mid: '中風量',
    wind_speed_text_high: '強風量',
    wind_speed_text_auto: '自動風量',
    button_cool: '冷房',
    button_heat: '暖房',
    button_dehumidify: '除湿',
    button_wind: '送風',
    button_auto: '自動',
    button_wind_direction: '風向',
  },
  light_panel: {
    actionSuccess: 'SUCCESS',
    button_on: 'ON',
    button_off: 'OFF',
    button_bright: '明るい',
    button_dark: '暗い',
    button_color_cold: '寒\n色',
    button_color_warm: '暖\n色',
  },
  fan_panel: {
    actionSuccess: 'SUCCESS',
    button_power: '電源',
    button_swing: '首振り',
    button_wind_speed: '風量',
    button_wind_speed_up: '風量+',
    button_wind_speed_down: '風量-',
  },
  custom_panel: {
    actionSuccess: 'SUCCESS',
    button_on: 'ON',
    button_off: 'OFF',
    button_ok: 'OK',
    button_left: '←',
    button_right: '→',
    button_plus: '＋',
    button_up: '↑',
    button_down: '↓',
    button_minus: '－',
  },
  humidifier_panel: {
    actionSuccess: 'SUCCESS',
  },
  general: {
    label: {
      name: '名称',
      wifi_permission_not_granted: '位置情報の利用を許可にしてください',
      location_permission_not_granted: '位置情報の利用を許可にしてください',
      save_qrlink_image_permission_not_granted:
        '写真のアクセスを許可にしてください',
      save_image_permission_not_granted: '写真のアクセスを許可にしてください',
      micorphone_permission_not_granted: 'マイクへのアクセスを許可してください',
      confirm_delete: '{{name}}を削除しますか？',
      general_error: 'エラー',
      server_error:
        'ただいま通信が混み合っている可能性がございます。\nしばらくしてから再度お試しください。',
      no_edit_permission: '編集権限はありません',
      no_delete_permission: '削除権限はありません',
    },
    date: {
      day: '日',
      week: '週',
      month: '月',
      full_time: 'YYYY年MM月DD日 HH時mm分',
      time_only: 'HH時mm分',
      date_time_format: 'M月D日 HH:mm',
      full_date_format: 'D/M/YYYY',
      full_date_time_format: 'D/M/YYYY HH:mm',
      full_date_day: 'YYYY年MM月DD日',
      full_date_week_range_start: 'YYYY年MM月DD日',
      full_date_week_range_end: 'MM月DD日',
      full_date_month: 'YYYY年MM月',
      previous_day: '前日',
      next_day: '翌日',
      today: '今日',
      date_format: 'MM月DD日',
      day_of_week_1: '月',
      day_of_week_2: '火',
      day_of_week_3: '水',
      day_of_week_4: '木',
      day_of_week_5: '金',
      day_of_week_6: '土',
      day_of_week_0: '日',
      time_format: 'HH:mm',
      hour_plain: '{{hour}}',
      hour: '{{hour}} 時',
      minute_plain: '{{minute}}',
      minute: '{{minute}} 分',
      duration_hour: '{{hour}} 時間',
      duration_minute: '{{minute}} 分',
      duration_hour_plain: '{{hour}}',
      duration_minute_plain: '{{minute}}',
      hour_minute: '{{hour}}:{{minute}}',
      hour_minute_range:
        '{{startHour}}:{{startMinute}}~{{endHour}}:{{endMinute}}',
    },
    geolocation: {
      locationAlert: {
        titleWhenNotEnabled: '位置情報の許可は未設定',
        titleWhenOff: '位置情報の許可は未設定',
        instructions:
          'バックグラウンドでの位置情報の利用を「常に許可」に変更必要です',
        cancelButton: 'キャンセル',
        settingsButton: '設定',
      },
    },
  },
  auth: {
    action: {
      login: 'ログイン',
      forget_password: 'パスワードを忘れました',
      register: '新規登録',
      resend: '再送信する',
    },
    login: {
      slogan: 'ようこそ\nHomeLinkへ',
      login_fail_message: 'ログインに失敗しました。',
      login_success_message: 'ログインに successful',
      reset_password_question: 'パスワードを再発行しますか？',
      action: {
        reset_password: 'パスワードの再発行',
      },
    },
    register: {
      title: '新規登録',
      step1_slogan: 'アカウントを登録しましょう',
      terms_1: '「',
      terms_2: '」と「',
      terms_3: '」をご一読のうえチェックしてください。',
      terms_service: '利用規約',
      terms_privacy: 'プライバシー規約',
      step2_slogan: 'パスワードを設定しましょう',
    },
    reset_password: {
      title: 'パスワードの再設定',
      step1_slogan: 'パスワードを再設定します',
      enter_email: 'メールアドレスを入力してください。',
      step2_slogan: 'パスワードを設定しましょう',
    },
    email: 'メールアドレス',
    email_tips:
      '認証コードを入力したメールアドレスへお送ります。\n※受信できない場合は迷惑メールフォルダもご確認ください。',
    email_cannot_be_empty: '入力に誤りがあります。',
    email_invalid_format: '入力に誤りがあります。',
    email_already_exists: 'アカウントが既に存在します。\n登録しますか？',
    email_not_exists: 'アカウントが存在しません',
    password: 'パスワード',
    password_cannot_be_empty: '入力に誤りがあります。',
    password_too_short: 'パスワードを８桁以上で入力してください',
    password_reset_done: '設定完了',
    set_password: 'パスワードを８桁以上で入力してください',
    enter_code_1: '',
    enter_code_2: ' にお送りしている認証コードを入力してください。',
    verification_code: '認証コード',
    verification_code_cannot_be_empty: '入力に誤りがあります。',
    verification_code_invalid: '認証コードが間違っています',
    verification_code_expired: '認証コードが無効になりました。',
    code_tips_line1_1: '',
    code_tips_line1_2: 'は',
    code_tips_line1_3: 'すると',
    code_tips_hightlight_1: '認証コード',
    code_tips_hightlight_2: '一定時間を経過',
    code_tips_line2_1: '',
    code_tips_line2_2: 'になりますので、ご注意ください。',
    code_tips_hightlight_3: '無効',
  },
  device: {
    home: {
      manage_family: 'ホーム管理',
      add_room: '部屋の追加',
      title: 'ホーム管理',
      list: 'ホームリスト',
      confirm_delete_room: 'この部屋を削除しますか？',
      add_new_device: 'デバイスの新規追加',
      add_by_qr_link: 'QR-Linkでの追加',
    },
    manage_families: {
      title: 'ホーム管理',
      enter_family_name: '名称を入力してください',
    },
    manage_accounts: {
      title: 'アカウント管理',
      enter_account_name: '名称を入力してください',
    },
    family_detail: {
      qr_code: '{{name}}のQRコード',
      qr_code_saved: 'スマートフォンに保存しました',
      manage_permission: '権限管理',
      manage_permission_reset: '初期化',
      family_name: 'ホーム名称',
      family_rooms: 'ルーム',
      family_rooms_count: '{{count}}部屋',
      cannot_delete_current_family: '使用中のホームは削除できません',
      change_family_name: '名称の変更をしますか',
      reset_message: '初期化しますか？',
      reset_detail: '初期化後、今までの利用者がご利用できなくなります。',
      reset_done: '初期化完了',
      reset_not_linked: '初期化完了',
    },
    scan_qr_link: {
      title: 'QRコードをスキャン',
      scan_tips:
        '枠内にQRコードが入るようにしてください。\n自動的にスキャンされます。',
      join_tips:
        'スキャン可能人数は、\nひとつのQRコードにつき\n１名のみですのでご注意ください。',
      invalid_qr_link: '無効のQRコード',
      unauthorized_qr_link: '無効のQRコード',
    },
    configure: {
      title: 'デバイスの追加',
      catalog: 'デバイス',
      existing: '追加済み',
      pending: '未設定',
    },
    catalog: {
      all: 'すべて',
      remote: 'リモコン',
      sensor: 'センサー',
      camera: 'カメラ',
      plug: 'プラグ',
      curtain: 'カーテン',
      switch: '照明スイッチ',
      waterHeater: '給湯器',
    },
    pending: {
      tips: '下記をタッチし、セットアップを完了してください。',
      no_device_tips: '未設定デバイスは見つかりませんでした。',
    },
    submit: {
      tips: '追加完了',
      name: '名称',
      room: '部屋',
    },
    configuration: {
      action: {
        troubleshooting: 'トラブルシューティング',
      },
      wifi: 'Wi-Fi:',
      wifi_not_connected: '未接続',
      should_connect_to_wifi: 'スマートフォンを\nWi-Fiに接続してください。',
      ios_wifi_bug:
        '（1）スマートフォンが Wi-Fi に接続しているかどうかご確認ください。\n（2）接続状態にもかかわらず、「Wi-Fi：未接続」と表示される場合、スマートフォンを再起動することにより通常通りに設定が可能となります。（現在IOSの問題により、一部の端末において当該事象が発生しております。）',
      wifi_24g_compatibility: '2.4GHz 対応 ※5GHz非対応',
      wifi_24g_not_connected: '2.4GHz 帯の Wi-Fi に接続してください。',
      wifi_switch: 'Wi-Fi を切替',
      ssid_cannot_be_empty: 'SSIDを入力してください',
      wifi_password_placeholder: 'パスワード',
      configuration_tips: 'ランプが消えましたら、セットアップ完了。',
      connect_wifi_tips_1:
        '（1）画面下部の「Wi-Fiを選択」をタッチ\n（2）下記デバイスのWi-Fiに接続：',
      connect_wifi_tips_2_icon_left: '　　　',
      connect_wifi_tips_2_icon_right: '　',
      connect_wifi_tips_3:
        '（3）接続後、本アプリ画面に戻る\n（4）通常使用しているWi-Fiに接続',
      select_wifi: 'Wi-Fiを選択',
      confirm_wifi: 'ネットワーク“{{ssid}}“に接続しましたか？',
      setup_failure: 'セットアップに失敗しました。',
      retry_tips: '上記を確認の上、リトライの場合はこちらへ ↓',
      troubleshooting_tips: 'セットアップできない場合はこちらへ ↓',
      troubleshoot_guide:
        'ランプの状態に応じて、下記のいずれかのボタンをタッチしてください。',
      troubleshoot_light_off: 'ランプが消えました',
      troubleshoot_light_on: 'ランプが点滅',
      troubleshoot_other_reason: 'その他の失敗原因',
    },
    notification: {
      history: '通知履歴',
      history_date_label: '{{date}}（{{dayOfWeek}}）',
    },
    detail: {
      title: '設定',
      name: '名称',
      room: '設置部屋',
    },
    change_device_name: '名称を入力してください。',
    change_device_room: '部屋を選択してください。',
    family_name_cannot_be_empty: '名称を入力してください',
    enter_room_name: '部屋の名前を入力してください。',
    room_name_cannot_be_empty: '名称を入力してください',
    room_name_too_long: '最大文字数は9文字です。',
    room_name_duplicated: 'すでに同じ名称があります',
    device_pending_tips: '未設定のデバイスがあります。',
    device_name_cannot_be_empty: '名称を入力してください',
    device_name_duplicated: 'すでに同じ名称があります',
    must_select_a_room: '部屋を選択してください',
  },
  appliance: {
    tv: 'テレビ',
    ac: 'エアコン',
    light: '照明',
    recorder: 'レコーダー',
    fan: '扇風機',
    humidifier: '加湿器',
    cleaner: '掃除機',
    theater: 'ホームシアター',
    custom: 'その他',
    send_code_fail: '送信失敗',
    add_appliances: {
      select_remote_control: 'リモコンを選択してください。',
    },
    select_appliance_device: {
      tips: 'デバイスを選択してください。',
      add_e_device_first:
        'デバイスが追加されていません。\n紐付けするデバイスを追加してください。',
      added: '追加済み',
      add_new_device: 'デバイスの新規追加',
    },
    select_appliance_brand: {
      select_brand: 'メーカーを選択してください 。',
      go_to_manual_learning: '該当メーカーがない場合は手動学習へ',
    },
    configure_ac: {
      tips_message: '家電が反応したら「OK」\nをタッチしてください。',
      tips_detail:
        'メーカーのリモコンを\nすべてダウンロード完了\n\n該当リモコンを\n自動マッチングします。',
      test_progress: '{{current}}/{{total}}',
      press_ok_tips: '家電が反応したら「OK」をタッチ',
      countdown_start: '次のリモコンの自動テスト開始まで',
      countdown_end: '秒',
      previous_test: '前のリモコン',
      next_test: '次のリモコン',
      use_current_panel: 'このリモコンを使用',
      testing: 'リモコンをテスト中',
      manual_learning: '手動学習',
      manual_learning_tips:
        '対応するリモコンが見つかりませんでした。\n手動学習を行ってください。',
      contact_support_tips:
        '※エアコンの型番をサポートまでご連絡頂くと、今後使用可能となります。',
    },
    configure: {
      tips: '家電の近くにデバイスを設置し、\n二つ以上のボタンをタッチして\n家電が反応したかどうかを\n確認してください。',
      did_appliance_respond: '家電は反応しましたか？',
      test_progress: 'テスト：{{current}}/{{total}}',
      next_test: '次のデータをテスト',
      previous_test: '前のデータをもう一度テスト',
      manual_learning: '手動学習へ',
      manual_learning_tips: '未学習ボタンは\nタッチして学習できます',
      no_matched_panel: '自動マッチング失敗！',
    },
    learning: {
      learn_tips:
        'リモコンを{{name}}に向けて\n学習したいボタンを押してください。',
      test_learning_result: '動作確認',
      test: 'テスト',
      confirm_learning_result: '反応はありましたか？',
      enter_button_name: 'ボタンの名前を入力してください。',
      button_name: 'ボタンの名称',
      button_name_cannot_be_empty: '名称を入力してください',
      button_name_too_long: '最大文字数は6文字です。',
      learning_error: '学習エラー',
      confirm_delete_button: '選択したボタンを削除しますか？',
      unlearned_button_tips: '未学習ボタンは\nタッチして学習できます。',
    },
    detail: {
      title: '設定',
      name: '名称',
      room: '設置部屋',
      custom_keys: 'ユーザー登録のボタン数',
      custom_keys_tips: 'リモコンボタンの長押しで再学習できます',
    },
    change_panel_name: '名称を入力してください。',
    panel_name_cannot_be_empty: '名称を入力してください',
    panel_name_duplicated: 'すでに同じ名称があります',
    change_panel_room: '部屋を選択してください。',
    must_select_a_room: '部屋を選択してください',
  },
  intelligence: {
    title: 'スマート',
    timer: {
      title: 'タイマー',
      add_tips: 'タイマーの新規追加',
      device_title: 'タイマー設定',
      device_add_tips: '詳細タイマー追加',
      no_timer: 'タイマーは設定されていません。',
      add_timer: 'タイマーを追加',
      turn_on: 'オンにする',
      turn_off: 'オフにする',
      repeat: '繰り返し',
      repeat_once: '一回実行',
      repeat_daily: '毎日',
      repeat_weekday: '平日',
      repeat_weekend: '週末',
      repeat_custom: 'カスタム',
      action: '動作',
      action_ac_tips: '現在のエアコン設定状態で実行',
      confirm_delete_timer: 'タイマーを削除しますか？',
    },
    controlAction: {
      add: '実行動作を追加',
      device_room: '（{{name}}）',
    },
    triggerCondition: {
      add: 'センサーを追加',
      device_room: '（{{name}}）',
    },
    scene: {
      title: 'シーン',
      good_morning: 'おはよう',
      good_night: 'おやすみ',
      see_you: 'いってきます',
      i_am_home: 'ただいま',
      acton_execution: '{{name}} 実行',
      enter_scene_name: 'シーン名を入力してください。',
      change_scene_name: '名称を入力してください。',
      scene_name_cannot_be_empty: '名称を入力してください',
      scene_name_too_long: '最大文字数は9文字です。',
      scene_name_duplicated: 'すでに同じ名称があります',
      confirm_delete_scene: 'シーンを削除しますか？',
      scene_name: 'シーン名',
      emtpy_action_tips: '設定後、ワンタッチで\n複数の家電を操作できます。',
      select_remote_control: 'リモコンを選択してください 。',
    },
    notification: {
      title: '通知',
      add_tips: '通知の新規追加',
      confirm_delete_notification: '通知を削除しますか？',
      notification_group_title: '以下の内容を通知します',
      edit_notification_text: '通知内容を入力してください。',
      notification_text: '通知内容',
      notification_text_cannot_be_empty: '通知内容を入力してください',
    },
    security: {
      title: 'ホームセキュリティ',
      title_wrapped: 'ホーム\nセキュリティ',
      confirm_delete_notification: 'ホームセキュリティを削除しますか？',
      switch_on: 'ON',
      switch_off: 'OFF',
    },
    linkage: {
      title: '連動',
      add_tips: '連動の新規追加',
      confirm_delete_linkage: '連動を削除しますか？',
      control_action_list_title: '以下の実行動作が開始されます。',
    },
    trigger: {
      condition_group_title: 'もし、下記の条件を満たした場合、',
      condition: '条件',
      condition_title: '条件設定',
      condition_new: '新規条件',
      condition_empty_tips: 'センサーの追加が必要です。',
      condition_value_eq: '等しい',
      condition_value_gt: 'に上がったら',
      condition_value_lt: 'に下がったら',
      condition_device_room: '（ {{name}} ）',
      select_device_title: 'センサーを選択',
      duration: '有効期間',
      duration_title: '有効期間設定',
      duration_next_day: '（翌日）',
      duration_separator: '-',
    },
    countdown: {
      unit: '分後',
      custom: 'カスタム',
      countdown: '切タイマー',
      countdown_hour_minute: '{{hour}}時間{{minute}}分後OFF',
      countdown_minute_second: '{{minute}}分{{second}}秒後OFF',
      countdown_second: '{{second}}秒後OFF',
      countdown_already_exists:
        '設定済みの「切タイマー」を削除後、新しく「切タイマー」を設定してください',
      countdown_delete_message: '切タイマーをキャンセルしますか?',
      countdown_delete: 'はい',
      countdown_cancel: 'いいえ',
    },
    geo_location: {
      title: 'GPSエリア',
      radius_text: '{{radius}}m',
    },
  },
  setting: {
    action: {
      logout: 'ログアウト',
      change_password: 'パスワードを変更',
      delete_account: 'アカウントを削除',
      connect_alexa: '連携へ',
      open_alexa_manual: 'Alexaマニュアル',
    },
    title: '設定',
    account_setting: 'アカウント',
    manual: 'サポート&マニュアル',
    connect_alexa: 'Alexa 連携',
    connect_google_assistant: 'GoogleAssistant 連携',
    online_support: 'サポート',
    configure: '設定',
    configure_vibration: 'バイブレーション',
    app_version: 'App Version',
    confirm_link: '該当スキルを有効にし、アカウントとAlexaをリンクしますか？',
    success_link: '連携完了\n音声で操作することができるようになりました',
    failure_link: '連携失敗',
    old_password_placeholder: '現在のパスワードを入力',
    new_password_placeholder: '新しいパスワードを入力',
    old_password_invalid: '現在のパスワードの入力間違いです',
    new_password_too_short: '新しいパスワードを8桁以上で入力してください',
  },
  hours: {
    hoursSetting: '営業時間を設定',
    settingMethod: '設定方法: ',
    hours: '営業時間: ',
    dayOff: '定休日',
  },
  calendar: {
    title: 'Calendar',
    clientName: '利用者様',
    clientInfo: '基本情報',
    clientMessage: 'コミュニケーション',
    clientNamePlaceHolder: '利用者様の情報を入力してください',
    clientAccount: 'APPアカウント',
    clientAccountPlaceHolder: '利用者様のアカウント情報を入力してください',
    paymentType: '診療種類',
    paymentTypePlaceHolder: '診療の種類を選択してください',
    insurancePayment: '保険診療',
    selfPayment: '自由診療',
    notSelected: '未選択',
    insuranceImage: '保険証画像',
    doctor: '担当医師',
    drugStore: '薬局',
    appointmentTime: '期間',
    appointmentStart: '開始時間',
    appointmentEnd: '終了時間',
    paperPrescription: '紙処方箋',
    notes: 'メモ',
    startAppointment: '診察開始',
    rebookAppointment: '次回予約',
    startPrescriptionAppointment: '説明開始',
    createAppointment: 'ビデオ通話作成＆利用者様に送信',
    cancelCreateAppointment: '新規作成をキャンセル',
    deleteAppointment: '予約の取消＆送信',
    updateAppointment: '編集を保存',
    cancelEditAppointment: '編集をキャンセル',
    outsideBusinessHours: '営業時間外です',
    patientInfoDialog: {
      title: '基本情報',
      name: '名称：',
      dob: '生年月日：',
      sex: '性別：',
      phoneNum: '電話番号：',
      insuranceNumber: '診療番号(保険者番号)：',
      address: '住所：',
    },
    requestAppointment: {
      title: '予約申込',
      name: '名前',
      account: 'APPアカウント',
      duration: '診療時間',
      department: '診療科',
      drugExplain: '説明時間',
      requestTime:
        '予約可能な希望日時を下記より選択し、利用者に送信してください。',
      selection1: '希望日時❶',
      selection2: '希望日時❷',
      selection3: '希望日時❸',
      send: '送信',
    },
    appointmentRequestList: {
      table: {
        header: '通知一覧',
        requestDate: '通知日時',
        patientName: '利用者様',
        timeRange: '診療時間',
        account: 'APPアカウント',
        status: '状態',
        statusActive: '確認済み',
        statusPending: '未確認（新規申込）',
        statusPast: '診察完了',
        statusCanceled: '未確認（予約取消）',
        statusPaid: '支払済',
      },
    },
    confirmCancelAppointment: {
      title: '予約取消',
      subtitle: '下記予約が取り消しました。',
    },
    confirmCancelAppointmentRequest: {
      title: '申込取消',
      subtitle: '下記申込が取り消しました。',
    },
    confirmDeleteAppointment: 'この予約を取り消しますか？',
    enterNumber: '入力待ち',
    changePrescription: '変更',
    enterFee: '入力待ち',
    changeFee: '変更',
    feePaid: '支払済み',
    selectPaymentType: '診療の種類を選択してください',
    enterMedicalFee: '診療費を入力してください',
    enterPrescriptionFee: '薬代を入力してください',
    enterPrescription: '処方箋番号を入力してください',
    medicalFee: '診療費',
    prescriptionFee: '薬代',
    prescription: '処方箋',
    medicalFeePlaceHolder: '50以上の金額を入力してください',
    minAmountError: '50以上の金額を入力してください',
    amountError: '有効な数値を入力してください',
    deliveryAddress: 'お届け先',
    confirmedDeliveryAddressDialog: {
      title: 'お届け先',
      name: '名前',
      phoneNum: '電話番号',
      address: '住所',
    },
  },
  videoCall: {
    openChat: 'メッセージ',
    endCall: '通話を終了',
    toggleVideo: 'カメラをオフ',
    toggleAudio: '音声をオフ',
  },
  chat: {
    fileText: '[文档]',
    imageText: '[写真]',
    imageTextEng: '[IMAGE]',
    chat: 'コミュニケーション',
  },
  hydro: {
    title: '水道',
    header: '水道データアップロード',
    usagePeriod: '水道使用期間',
    usagePeriodPlaceholder: '水道使用期間を選択してください',
    csvSelect: 'csv ファイルを選択',
    usagePeriodHistory: 'アップロード履歴',
    notYetUploaded: 'データなし',
    uploadButton: 'アップロード',
    uploading: 'アップロードしています',
    uploadSuccess: 'アップロード完了',
    uploadFailed: 'アップロード失敗',
  },
  mamoleo: {
    title: '水道',
    header: 'ライセンスキー一覧更新',
    newestKeyFile: '最新ファイル:',
    keyFileHistory: 'アップロード履歴',
    csvSelect: 'csv ファイルを選択',
    notYetUploaded: 'データなし',
    uploadButton: 'アップロード',
    uploading: 'アップロードしています',
    uploadSuccess: 'アップロード完了',
    uploadFailed: 'アップロード失敗',
  },
  pay: {
    paySuccess: 'お支払い完了',
    payFailed: 'お支払い失敗',
    payAction: 'お支払い',
    paid: '支払済み',
    currency_unit: '円',
    paySuccessTitle: 'お支払い完了',
    paySuccessDetail:
      '処方箋を送信します。\n処方箋はオンライン医療サービス画面で確認してください',
  },
  payErrors: {
    unknownReason: '未知の支払い失敗の理由: {{reasonCode}}',
    unknown: '未知の支払い失敗の理由',
    K82: 'カード番号の入力内容不正。',
    C16: 'カード番号エラー',
    C17: 'カード番号体系エラー',
    G65: 'カード番号エラー',
    K83: 'カード有効期限の入力内容不正。',
    G83: '有効期限エラー',
    G12: 'カード使用不可',
    G56: '無効カード',
    G61: '無効カード',
    G42: '暗証番号エラー',
    G44: 'セキュリティコード誤り',
    G45: 'セキュリティコード入力無',
    G54: '利用回数エラー',
    G55: '限度額オーバー',
    U06: 'セッションの有効期限切れ',
  },
  creditCard: {
    invalid_card_no: 'カード番号の長さが無効です',
    invalid_valid_month: '有効期限の月が無効です',
    invalid_valid_year: '有効期限の年が無効です',
    invalid_ccv: 'CVCの長さが無効です',
  },
  date: {
    day_of_week_1: '月',
    day_of_week_2: '火',
    day_of_week_3: '水',
    day_of_week_4: '木',
    day_of_week_5: '金',
    day_of_week_6: '土',
    day_of_week_0: '日',
  },
};

export default JPN;
